import { render } from "./Tile.vue?vue&type=template&id=f35ddc18&scoped=true&ts=true"
import script from "./Tile.vue?vue&type=script&lang=ts"
export * from "./Tile.vue?vue&type=script&lang=ts"

import "./Tile.vue?vue&type=style&index=0&id=f35ddc18&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35ddc18"]])

export default __exports__